export function downloadFile(
  content: string | Uint8Array<ArrayBuffer>,
  filename: string,
  mimeType = "text/csv;charset=utf-8;"
) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

export function downloadCsv(content: string, filename: string) {
  downloadFile(content, filename, "text/csv;charset=utf-8;");
}

export function downloadBase64Csv(base64Data: string, filename: string) {
  const binaryString = atob(base64Data);
  const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
  downloadFile(bytes, filename, "text/csv;charset=utf-8;");
}
